module.exports = __webpack_public_path__ + "img/40.5740df84.png";